import { ArrowUp, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Nav";
import { scrollToId, CONTACT_EMAIL, WHATSAPP_NUMBER } from "@/config";

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/8 bg-zinc-950/60 pt-20 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-start justify-between gap-12 pb-16">
          <div className="max-w-sm">
            <div className="flex items-center gap-3">
              <Logo size={40} />
              <span className="font-syne text-xl font-bold">
                MPX<span className="text-cyan-400"> Digital</span>
              </span>
            </div>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
              Siti web ad alto impatto per attività locali ed e-commerce.
              Progettati e sviluppati a mano, dal creatore di affige.it.
            </p>
            <a
              href="https://affige.it"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-1.5 text-sm text-cyan-400 hover:text-cyan-300 transition-colors"
              data-testid="footer-affige-link"
            >
              Scopri affige.it
              <ExternalLink size={14} />
            </a>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-4">Navigazione</p>
            <div className="flex flex-col gap-2.5">
              {[
                ["Servizi", "#servizi"],
                ["Portfolio", "#portfolio"],
                ["Metodo", "#metodo"],
                ["Preventivo", "#preventivo"],
                ["Contatti", "#contatti"],
              ].map(([label, href]) => (
                <button
                  key={href}
                  onClick={() => scrollToId(href)}
                  className="text-left text-sm text-zinc-400 hover:text-cyan-300 transition-colors"
                  data-testid={`footer-link-${label.toLowerCase()}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 mb-4">Contatti diretti</p>
            <div className="flex flex-col gap-2.5 text-sm text-zinc-400">
              <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-cyan-300 transition-colors" data-testid="footer-email-link">
                {CONTACT_EMAIL}
              </a>
              <a
                href={`https://wa.me/${WHATSAPP_NUMBER}`}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-cyan-300 transition-colors"
                data-testid="footer-whatsapp-link"
              >
                WhatsApp diretto
              </a>
              <span className="text-zinc-500">Italia · Remote</span>
            </div>
          </div>
        </div>

        <div className="select-none text-center font-syne font-extrabold leading-none tracking-tight text-[16vw] text-white/5" aria-hidden="true">
          MPX DIGITAL
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-white/8 py-6">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <p className="text-xs text-zinc-500">
              © {new Date().getFullYear()} MPX Digital — Tutti i diritti riservati.
            </p>
            <Link
              to="/privacy"
              className="text-xs text-zinc-500 hover:text-cyan-300 transition-colors"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </Link>
          </div>
          <button
            onClick={() => window.__lenis?.scrollTo(0) || window.scrollTo({ top: 0, behavior: "smooth" })}
            className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-xs text-zinc-400 transition-all duration-300 hover:border-cyan-400/50 hover:text-cyan-300"
            data-testid="footer-scroll-top"
          >
            Torna su
            <ArrowUp size={14} />
          </button>
        </div>
      </div>
    </footer>
  );
};
